import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-wbs-allocation-components',
  templateUrl: './wbs-allocation-components.component.html',
  styleUrls: ['./wbs-allocation-components.component.css']
})
export class WbsAllocationComponentsComponent implements OnInit, OnDestroy {

  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.WBSAllocationComponents.columns;
    this.data = this.report.WBSAllocationComponents.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.WBSAllocationComponents.data;
    const gridInstance = this.gridContext.getInstance('WBSAllocationComponents');
    gridInstance.loadData(this.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/wbs-allocation-components/wbs-allocation-components.component.ts